<template>
  <Jazzicon class="object-cover" v-bind:seed="agentAvatarSeed" :diameter="parseInt(diameter) || 55" :class="classes || 'w-14 h-14'" v-tippy />
  <tippy v-if="!plain">{{ agent.attributes.name }}</tippy>
</template>

<script>
import Jazzicon from 'vue3-jazzicon/src/components'

export default {
  name: 'AgentAvatar',
  props: ['agent', 'classes', 'diameter', 'plain'],
  components: {
    Jazzicon,
  },
  computed: {
    agentAvatarSeed() {
      let seed = 0;
      let id = this.agent.id;
      let index = id.length;
      while (index--) {
          seed = seed + id[index].charCodeAt(0);
      }
      return seed;
    },
  },

}
</script>
